import * as yup from "yup";

import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import { DEFAULT_AUTO_ID_KEY } from "@/react/services/api/transforms";

const schema = yup.object({
  [DEFAULT_AUTO_ID_KEY]: yup.string().unique(), // @see schemaFields.js for `unique` method
  ip: yup.string(),
  status: yup.string(),
  reason: yup.string(),
  email: yup.string().required().email(),
  created: yup.string(),
});

addKeyToFieldsRecursively(schema);

export default schema;
